<template>
  <CModal
    v-model:visible="showModal"
    :title="title"
    size="lg"
    color="primary"
    @close="closeModal"
  >
    <div class="mb-3">
      <CInput
        v-model="filters.search"
        :placeholder="searchPlaceholder"
        class="mb-0"
        @update:value="debouncedSearch"
        @keyup.enter="triggerSearch"
      >
        <template #append>
          <CButton
            color="primary"
            @click="triggerSearch"
          >
            Search
          </CButton>
        </template>
      </CInput>
    </div>

    <CDataTable
      :items="data"
      :fields="fields"
      :loading="loading"
      :pagination="false"
      hover
      striped
      class="mb-0"
    >
      <template
        v-for="(_, slotName) in $slots"
        #[slotName]="slotProps"
      >
        <slot
          :name="slotName"
          v-bind="slotProps"
        />
      </template>

      <template
        v-if="!$slots.actions"
        #actions="{ item }"
      >
        <td class="text-right">
          <CButton
            size="sm"
            color="success"
            class="text-white"
            @click="selectItem(item)"
          >
            Select
          </CButton>
        </td>
      </template>

      <template #no-items-view>
        <div class="text-center p-3 text-muted">
          {{ loading ? 'Loading...' : 'No items found.' }}
        </div>
      </template>
    </CDataTable>

    <div
      v-if="options.last_page > 1"
      class="mt-3 d-flex justify-content-end"
    >
      <pagination
        :current-page="options.page"
        :last-page="options.last_page"
        @paginate="pageChange"
      />
    </div>

    <template #footer>
      <CButton
        color="secondary"
        @click="closeModal"
      >
        Cancel
      </CButton>
    </template>
  </CModal>
</template>

<script>
import externalTable from '@/mixins/externalTable';

export default {
  name: 'BaseSelectModal',
  mixins: [externalTable],
  emits: ['selected'],
  props: {
    title: { type: String, default: 'Select Item' },
    endpoint: { type: String, required: true },
    fields: { type: Array, required: true },
    searchPlaceholder: { type: String, default: 'Search...' },
  },
  data() {
    return {
      showModal: false,
      filters: {
        search: '',
      },
      url: this.endpoint,
      searchTimeout: null,
    };
  },
  watch: {
    endpoint(newVal) {
      this.url = newVal;
    },
  },
  methods: {
    open() {
      this.showModal = true;
      this.filters.search = '';
      this.options.page = 1;
      this.fetchData();
    },

    closeModal() {
      this.showModal = false;
    },

    selectItem(item) {
      this.$emit('selected', item);
      this.showModal = false;
    },

    debouncedSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.options.page = 1;
        this.fetchData();
      }, 500);
    },

    triggerSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.options.page = 1;
      this.fetchData();
    },
  },
};
</script>
